var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeartFlagFavoriteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1358_3041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H28V40C28 42.2091 26.2091 44 24 44H4C1.79086 44 0 42.2091 0 40V0Z",
    fill: "#F4C343"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1358_3041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 0H0C0 0 0 16.5545 0 18.1388V41.1265C0 42.7108 1.25627 44 2.8 44H25.2C26.7437 44 28 42.7108 28 41.1265V18.1388C28 16.5545 28 0 28 0ZM21.2529 31.009L14.6561 37.778C14.4741 37.9648 14.2352 38.0586 13.9963 38.0586C13.7573 38.0586 13.5184 37.9648 13.3364 37.778L6.73773 31.0071C4.56027 28.7725 4.55933 25.128 6.73587 22.8829C7.79613 21.8005 9.20267 21.2067 10.7007 21.2067C11.9056 21.2067 13.0471 22.1722 13.9963 22.8829C14.9483 22.1722 16.0953 21.2067 17.2993 21.2067C18.7983 21.2067 20.2029 21.8015 21.2548 22.881C22.3132 23.9671 22.8956 25.4144 22.8928 26.9555C22.8919 28.4909 22.3095 29.9315 21.2529 31.009Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1358_3041",
    x: -5,
    y: -1,
    width: 38,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.86 0 0 0 0 0.72283 0 0 0 0 0.3612 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1358_3041"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1358_3041",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1358_3041"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H28V40C28 42.2091 26.2091 44 24 44H4C1.79086 44 0 42.2091 0 40V0Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFlagFavoriteIcon);
export default __webpack_public_path__ + "static/media/heart_flag_favorite_icon.39357aa30077794f172eb95cf5edfe0f.svg";
export { ForwardRef as ReactComponent };